import template from './steps-indicator.jade';

/**
 * A step sequence display, listing [size] number of steps, highlighting [current].
 */
let stepsIndicator = () => ({
  restrict: 'E',
  template,
  scope: {
    size: '=',
    current: '=',
  },

  link(scope, element, attrs) {
    scope.steps = [...Array(scope.size).keys()];
  },
});

export default angular
  .module('app.directives.steps-indicator', [])
  .directive('stepsIndicator', stepsIndicator);
